import * as Dtos from "../dtos/Tmd.dtos";

export const
    LoadTrialPersonnelById: ITrialPersonnelLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALPERSONNEL_LOAD_BY_ID,
            id
        }
    },
    LoadTrialPersonnelsByPersonnelId: ITrialPersonnelsLoadByPersonnelIdActionCreator = (personnelId) => {
        return {
            type: ACTION_TRIALPERSONNELS_LOAD_BY_PERSONNEL_ID,
            personnelId
        }
    },
    LoadTrialPersonnelsByTrialId: ITrialPersonnelsLoadByTrialIdActionCreator = (trialId, groupLevelTypeId) => {
        return {
            type: ACTION_TRIALPERSONNELS_LOAD_BY_TRIAL_ID,
            trialId,
            groupLevelTypeId
        }
    },
    LoadTrialPersonnelsByInstitutionId: ITrialPersonnelsLoadByInstitutionIdActionCreator = (institutionId, groupLevelTypeId) => {
        return {
            type: ACTION_TRIALPERSONNELS_LOAD_BY_INSTITUTION_ID,
            institutionId,
            groupLevelTypeId
        }
    },
    LoadTrialPersonnelsByTrialInstitutionId: ITrialPersonnelsLoadByTrialInstitutionIdActionCreator = (trialInstitutionId, groupLevelTypeId) => {
        return {
            type: ACTION_TRIALPERSONNELS_LOAD_BY_TRIALINSTITUTION_ID,
            trialInstitutionId,
            groupLevelTypeId
        }
    },
    LoadTrialPersonnelsByTrialGroupId: ITrialPersonnelsLoadByTrialGroupIdActionCreator = (trialGroupId, groupLevelTypeId) => {
        return {
            type: ACTION_TRIALPERSONNELS_LOAD_BY_TRIALGROUP_ID,
            trialGroupId,
            groupLevelTypeId
        }
    },
    LoadTrialPersonnelsByGroupId: ITrialPersonnelsLoadByGroupIdActionCreator = (groupId, groupLevelTypeId) => {
        return {
            type: ACTION_TRIALPERSONNELS_LOAD_BY_GROUP_ID,
            groupId,
            groupLevelTypeId
        }
    },
    LoadSuccess: ITrialPersonnelLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALPERSONNEL_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialPersonnelLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALPERSONNEL_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialPersonnel: ITrialPersonnelSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALPERSONNEL_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialPersonnelSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALPERSONNEL_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialPersonnelSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALPERSONNEL_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialPersonnel: ITrialPersonnelCreateActionCreator = (trialId: number | null, institutionId: number | null, groupId: number | null) => {

        return {
            type: ACTION_TRIALPERSONNEL_CREATE,
            trialId,
            institutionId,
            groupId
        }
    },
    CreateSuccess: ITrialPersonnelCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALPERSONNEL_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialPersonnelCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALPERSONNEL_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialPersonnel: ITrialPersonnelValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALPERSONNEL_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialPersonnelValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALPERSONNEL_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialPersonnelValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALPERSONNEL_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialPersonnelClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALPERSONNEL_CLEAR,
            propertiesToClear
        }
    };



export const
    ACTION_TRIALPERSONNEL_LOAD_BY_ID = "ACTION_TRIALPERSONNEL_LOAD_BY_ID",
    ACTION_TRIALPERSONNELS_LOAD_BY_PERSONNEL_ID = "ACTION_TRIALPERSONNELS_LOAD_BY_PERSONNEL_ID",
    ACTION_TRIALPERSONNELS_LOAD_BY_TRIAL_ID = "ACTION_TRIALPERSONNELS_LOAD_BY_TRIAL_ID",
    ACTION_TRIALPERSONNELS_LOAD_BY_INSTITUTION_ID = "ACTION_TRIALPERSONNELS_LOAD_BY_INSTITUTION_ID",
    ACTION_TRIALPERSONNELS_LOAD_BY_TRIALINSTITUTION_ID = "ACTION_TRIALPERSONNELS_LOAD_BY_TRIALINSTITUTION_ID",
    ACTION_TRIALPERSONNELS_LOAD_BY_TRIALGROUP_ID = "ACTION_TRIALPERSONNELS_LOAD_BY_TRIALGROUP_ID",
    ACTION_TRIALPERSONNELS_LOAD_BY_GROUP_ID = "ACTION_TRIALPERSONNELS_LOAD_BY_GROUP_ID",
    ACTION_TRIALPERSONNEL_LOAD_SUCCESS = "ACTION_TRIALPERSONNEL_LOAD_SUCCESS",
    ACTION_TRIALPERSONNEL_LOAD_FAILURE = "ACTION_TRIALPERSONNEL_LOAD_FAILURE",

    ACTION_TRIALPERSONNEL_SAVE = "ACTION_TRIALPERSONNEL_SAVE",
    ACTION_TRIALPERSONNEL_SAVE_SUCCESS = "ACTION_TRIALPERSONNEL_SAVE_SUCCESS",
    ACTION_TRIALPERSONNEL_SAVE_FAILURE = "ACTION_TRIALPERSONNEL_SAVE_FAILURE",

    ACTION_TRIALPERSONNEL_CREATE = "ACTION_TRIALPERSONNEL_CREATE",
    ACTION_TRIALPERSONNEL_CREATE_SUCCESS = "ACTION_TRIALPERSONNEL_CREATE_SUCCESS",
    ACTION_TRIALPERSONNEL_CREATE_FAILURE = "ACTION_TRIALPERSONNEL_CREATE_FAILURE",

    ACTION_TRIALPERSONNEL_VALIDATE = "ACTION_TRIALPERSONNEL_VALIDATE",
    ACTION_TRIALPERSONNEL_VALIDATE_SUCCESS = "ACTION_TRIALPERSONNEL_VALIDATE_SUCCESS",
    ACTION_TRIALPERSONNEL_VALIDATE_FAILURE = "ACTION_TRIALPERSONNEL_VALIDATE_FAILURE",

    ACTION_TRIALPERSONNEL_CLEAR = "ACTION_TRIALPERSONNEL_CLEAR";


export interface ITrialPersonnelLoadSuccessAction {
    type: "ACTION_TRIALPERSONNEL_LOAD_SUCCESS";
    formData: Dtos.TrialPersonnel | Dtos.TrialPersonnel[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialPersonnelLoadSuccessActionCreator {
    (
        formData: Dtos.TrialPersonnel | Dtos.TrialPersonnel[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialPersonnelLoadSuccessAction;
}

export interface ITrialPersonnelLoadFailureAction {
    type: "ACTION_TRIALPERSONNEL_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialPersonnelLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialPersonnelLoadFailureAction;
}

export interface ITrialPersonnelLoadByIdAction {
    type: "ACTION_TRIALPERSONNEL_LOAD_BY_ID";
    id: number;
}

export interface ITrialPersonnelLoadByIdActionCreator {
    (id: number): ITrialPersonnelLoadByIdAction;
}

export interface ITrialPersonnelsLoadByPersonnelIdAction {
    type: "ACTION_TRIALPERSONNELS_LOAD_BY_PERSONNEL_ID";
    personnelId: number;
}

export interface ITrialPersonnelsLoadByPersonnelIdActionCreator {
    (personnelId: number): ITrialPersonnelsLoadByPersonnelIdAction;
}

export interface ITrialPersonnelsLoadByTrialIdAction {
    type: "ACTION_TRIALPERSONNELS_LOAD_BY_TRIAL_ID";
    trialId: number;
    groupLevelTypeId: number | null;
}

export interface ITrialPersonnelsLoadByTrialIdActionCreator {
    (trialId: number, groupLevelTypeId: number | null): ITrialPersonnelsLoadByTrialIdAction;
}

export interface ITrialPersonnelsLoadByInstitutionIdAction {
    type: "ACTION_TRIALPERSONNELS_LOAD_BY_INSTITUTION_ID";
    institutionId: number;
    groupLevelTypeId: number | null;
}

export interface ITrialPersonnelsLoadByInstitutionIdActionCreator {
    (institutionId: number, groupLevelTypeId: number | null): ITrialPersonnelsLoadByInstitutionIdAction;
}

export interface ITrialPersonnelsLoadByTrialInstitutionIdAction {
    type: "ACTION_TRIALPERSONNELS_LOAD_BY_TRIALINSTITUTION_ID";
    trialInstitutionId: number;
    groupLevelTypeId: number | null;
}

export interface ITrialPersonnelsLoadByTrialInstitutionIdActionCreator {
    (trialInstitutionId: number, groupLevelTypeId: number | null): ITrialPersonnelsLoadByTrialInstitutionIdAction;
}

export interface ITrialPersonnelsLoadByTrialGroupIdAction {
    type: "ACTION_TRIALPERSONNELS_LOAD_BY_TRIALGROUP_ID";
    trialGroupId: number;
    groupLevelTypeId: number | null;
}

export interface ITrialPersonnelsLoadByTrialGroupIdActionCreator {
    (trialGroupId: number, groupLevelTypeId: number | null): ITrialPersonnelsLoadByTrialGroupIdAction;
}

export interface ITrialPersonnelsLoadByGroupIdAction {
    type: "ACTION_TRIALPERSONNELS_LOAD_BY_GROUP_ID";
    groupId: number;
    groupLevelTypeId: number | null;
}

export interface ITrialPersonnelsLoadByGroupIdActionCreator {
    (groupId: number, groupLevelTypeId: number | null): ITrialPersonnelsLoadByGroupIdAction;
}

export interface ITrialPersonnelSaveAction {
    type: "ACTION_TRIALPERSONNEL_SAVE";
    formData: Dtos.TrialPersonnel;

}

export interface ITrialPersonnelSaveActionCreator {
    (
        formData: Dtos.TrialPersonnel,
    ): ITrialPersonnelSaveAction;
}

export interface ITrialPersonnelSaveSuccessAction {
    type: "ACTION_TRIALPERSONNEL_SAVE_SUCCESS";
    formData: Dtos.TrialPersonnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialPersonnelSaveSuccessActionCreator {
    (
        formData: Dtos.TrialPersonnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialPersonnelSaveSuccessAction;
}

export interface ITrialPersonnelSaveFailureAction {
    type: "ACTION_TRIALPERSONNEL_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialPersonnelSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialPersonnelSaveFailureAction;
}

export interface ITrialPersonnelCreateAction {
    type: "ACTION_TRIALPERSONNEL_CREATE";
    trialId: number | null;
    institutionId: number | null;
    groupId: number | null;
}

export interface ITrialPersonnelCreateActionCreator {
    (trialId: number | null, institutionId: number | null, groupId: number | null): ITrialPersonnelCreateAction
}

export interface ITrialPersonnelCreateSuccessAction {
    type: "ACTION_TRIALPERSONNEL_CREATE_SUCCESS";
    formData: Dtos.TrialPersonnel;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ITrialPersonnelCreateSuccessActionCreator {
    (
        formData: Dtos.TrialPersonnel,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialPersonnelCreateSuccessAction;
}

export interface ITrialPersonnelCreateFailureAction {
    type: "ACTION_TRIALPERSONNEL_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialPersonnelCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialPersonnelCreateFailureAction;
}

export interface ITrialPersonnelValidateAction {
    type: "ACTION_TRIALPERSONNEL_VALIDATE";
    formData: Dtos.TrialPersonnel;

}

export interface ITrialPersonnelValidateActionCreator {
    (
        formData: Dtos.TrialPersonnel,
    ): ITrialPersonnelValidateAction;
}

export interface ITrialPersonnelValidateSuccessAction {
    type: "ACTION_TRIALPERSONNEL_VALIDATE_SUCCESS";
    formData: Dtos.TrialPersonnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialPersonnelValidateSuccessActionCreator {
    (
        formData: Dtos.TrialPersonnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialPersonnelValidateSuccessAction;
}

export interface ITrialPersonnelValidateFailureAction {
    type: "ACTION_TRIALPERSONNEL_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialPersonnelValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialPersonnelValidateFailureAction;
}

export interface ITrialPersonnelClearAction {
    type: "ACTION_TRIALPERSONNEL_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialPersonnelClearActionCreator {
    (propertiesToClear?: string[]): ITrialPersonnelClearAction;
}

export type TrialPersonnelAction =
    ITrialPersonnelLoadByIdAction |
    ITrialPersonnelsLoadByPersonnelIdAction |
    ITrialPersonnelsLoadByTrialIdAction |
    ITrialPersonnelsLoadByInstitutionIdAction |
    ITrialPersonnelsLoadByTrialInstitutionIdAction |
    ITrialPersonnelsLoadByTrialGroupIdAction |
    ITrialPersonnelsLoadByGroupIdAction |
    ITrialPersonnelLoadFailureAction |
    ITrialPersonnelLoadSuccessAction |
    ITrialPersonnelSaveAction |
    ITrialPersonnelSaveSuccessAction |
    ITrialPersonnelSaveFailureAction |
    ITrialPersonnelCreateAction |
    ITrialPersonnelCreateSuccessAction |
    ITrialPersonnelCreateFailureAction |
    ITrialPersonnelValidateAction |
    ITrialPersonnelValidateSuccessAction |
    ITrialPersonnelValidateFailureAction |
    ITrialPersonnelClearAction;
